import { memo } from "react";
import ReactDOM from "react-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
const Announcement = () => {
  const setAnnouncement = useContextSelector(AuthContext, (ctx) => {
    return ctx.setAnnouncement;
  });
  return ReactDOM.createPortal(
    <div className="cdk-overlay-container">
      <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
      <div
        className="cdk-global-overlay-wrapper"
        dir="ltr"
        style={{
          "-webkit-box-pack": "center",
          "-webkit-justify-content": "center",
          "-ms-flex-pack": "center",
          "justify-content": "center",
          "-webkit-align-items": "center",
          "-webkit-box-align": "center",
          "-ms-flex-align": "center",
          "align-items": "center",
        }}
      >
        <div
          id="cdk-overlay-6"
          className="cdk-overlay-pane dialog-panel"
          style={{ position: "static" }}
        >
          <app-dialog _nghost-serverapp-c33280995>
            <div _ngcontent-serverapp-c33280995 className="popup" id="dialog-6">
              <div
                _ngcontent-serverapp-c33280995
                className="popup__header"
              ></div>
              <div _ngcontent-serverapp-c33280995 className="popup__content">
                <app-notify-info
                  _nghost-serverapp-c4275207528
                  className="ng-tns-c4275207528-67 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c4275207528
                    id="popInbox"
                    className="pop-wrap ng-tns-c4275207528-67 ng-trigger ng-trigger-popWrapTriggerAni show ani ng-star-inserted"
                  >
                    <a
                      onClick={() => setAnnouncement(false)}
                      _ngcontent-serverapp-c4275207528
                      className="btn-close ng-tns-c4275207528-67"
                      style={{
                        maskImage: 'url("/assets/Other/icon-close.svg")',
                      }}
                    />
                    <div
                      _ngcontent-serverapp-c4275207528
                      className="pop-title ng-tns-c4275207528-67"
                    >
                      <h3
                        _ngcontent-serverapp-c4275207528
                        className="ng-tns-c4275207528-67"
                      >
                        {" "}
                        Official Alternative Login Links{" "}
                      </h3>
                    </div>
                    <div
                      _ngcontent-serverapp-c4275207528
                      className="pop-inner content-style ng-tns-c4275207528-67"
                    >
                      <p>
                        If you're unable to access bajifair through other
                        network pages, you can use any of the following official
                        alternative login links:{" "}
                      </p>
                    </div>
                  </div>

                  <div
                    _ngcontent-serverapp-c4275207528
                    className="pop-bg ng-trigger ng-trigger-popBgTriggerAni ng-tns-c4275207528-67 ng-star-inserted"
                    style={{ display: "block" }}
                  />
                </app-notify-info>
              </div>
            </div>
          </app-dialog>
        </div>
      </div>
    </div>,
    document.getElementById("overlay"),
  );
};

export default memo(Announcement);
